module.exports = __webpack_public_path__ + "static/media/likeFill.b85a6c4e.svg";